module.exports = __webpack_public_path__ + "static/media/krusty.84ff8b75.jpg";